import Vue from 'vue'
import Router from 'vue-router'
import HomeView from './views/HomeView.vue'
import EditView from './views/EditView.vue'

Vue.use(Router)

export default new Router({
	base: '/',
	mode: 'history',
	linkActiveClass : 'routerLink--active',
	linkExactActiveClass : 'routerLink--exactActive',
	routes: [
		{
			path: '/',
			name: 'EditView',
			component: EditView,
			pathToRegexpOptions: { strict: true },
		},		
		/*
		{
			path: '/',
			name: 'HomeView',
			component: HomeView,
			pathToRegexpOptions: { strict: true },
		},
		{
			path: "/edit", 
			name: 'EditView',
			pathToRegexpOptions: { strict: true },
			component: () =>
				import ('./views/EditView.vue')			
		},
		*/
	]
})
